import React from 'react';
import RadioContext from './RadioContext';
import utils from './utils';
import Text from '../../Text/Text';
import Fade from '../../Transitions/Fade/Fade';

import './RadioGroup.scss';

export interface RadioGroupProps {
    /**
     * Name context
     */
    name: any;
    /**
     * Value context
     */
    value?: string;
    /**
     * Error message
     */
    error?: string;
    /**
     * On change method
     */
    onChange?(): any;
    /**
     * Children node
     */
    children?: React.ReactNode;
}

const RadioGroup: React.FC<RadioGroupProps> = React.forwardRef(
    ({ name, value = '', error, onChange = () => {}, children }, ref) => {
        const rootRef = React.useRef(null);
        const handleRef = utils.useForkRef(ref, rootRef);

        return (
            <RadioContext.Provider value={{ name, selected: value, onChange } as any}>
                <div className="radio-group" ref={handleRef}>
                    {children}
                </div>
                {!!error && (
                    <Fade className="radio-group__error">
                        <Text tag="span" size="12" color="error">
                            {error}
                        </Text>
                    </Fade>
                )}
            </RadioContext.Provider>
        );
    }
);

export default RadioGroup;
